new (window as Window).Swiper('.image-slider', {
	slidesPerView: 1.1,
	slidesPerGroup: 1,
	spaceBetween: 16,
	shortSwipes: false,
	longSwipersMs: 200,
	longSwipesRatio: 0.3,
	a11y: false,

	navigation: {
		nextEl: '.image-slider__next',
		prevEl: '.image-slider__prev',
	},
	breakpoints: {
		560: {
			slidesPerView: 2.2,
			slidesPerGroup: 1,
			spaceBetween: 28,
		},
		992: {
			slidesPerView: 2.7,
			slidesPerGroup: 1,
			spaceBetween: 28,
		},
		1304: {
			slidesPerView: 3,
			slidesPerGroup: 1,
			spaceBetween: 28,
		},
	},
});
const modalSwiper = new (window as Window).Swiper('.modal-gallery', {
	slidesPerView: 1,
	spaceBetween: 16,
	effect: 'fade',
	fadeEffect: {
		crossFade: true,
	},
	navigation: {
		nextEl: '.modal-gallery__next',
		prevEl: '.modal-gallery__prev',
	},
	breakpoints: {
		992: {
			slidesPerView: 1,
			spaceBetween: 28,
		},
	},
});

const sliders = document.querySelectorAll('.image-slider');
sliders.forEach((slider) => {
	const sliderItems = slider.querySelectorAll('[data-slide-index]');
	sliderItems.forEach((sliderItem) => {
		if (sliderItem instanceof HTMLElement) {
			sliderItem.addEventListener('click', function () {
				modalSwiper.slideTo(sliderItem.dataset.slideIndex);
			});
		}
	});
});
